module.exports = "/_next/static/images/14e77fafd0502b6889e0e72fe6b68914-app-screenshots-md@1x.jpg";